<template>
  <div>
    <el-dialog
      :title="smallSortData.title"
      :visible.sync="smallSortData.show"
      center
      width="1200px"
    >
      <div class="game-box">
        <div
          v-for="(item, index) in dataList"
          :key="index"
          class="gameItem"
          v-show="item.tableData.length"
        >
          <el-table
            row-key="id"
            :id="`sortTable${index + 1}`"
            :data="item.tableData"
            border
            :cell-style="{ padding: '1' }"
          >
            <el-table-column
              align="center"
              width="100px"
              prop="name"
              :label="item.name"
            ></el-table-column>
            <el-table-column align="center"  :label="$t('Actions')" width="100px">
              <template slot-scope="scope">
                <el-switch
                  v-model="item.tableData[scope.$index].checked"
                  :width="35"
                  :inactive-text="
                    item.tableData[scope.$index].checked ? $t('Display') : $t('Hide')
                  "
                  @change="$forceUpdate()"
                  style="margin-right: 5px"
                >
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSort(2)"
          >{{$t('SaveCurrentDomain')}}</el-button
        >
        <el-button type="primary" @click="confirmSort(1)"
          >{{$t('SaveAllDomains')}}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import { app } from "@/api/app.js";
export default {
  props: {
    smallSortData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dataList: [],
      gameList: [
        { id: 1, state: 1, name: "哈希竞猜" },
        { id: 2, state: 1, Name: this.$t('common.comFooter.game1') },
        { id: 3, state: 1, name: "棋牌游戏" },
        { id: 4, state: 1,  Name: this.$t('common.comFooter.game5')},
        { id: 5, state: 1, name: this.$t('Blockchain'), },
        { id: 6, state: 1, name:this.$t('betRecord.tHead2')  },
        { id: 7, state: 1, name: "体育竞技" },
        { id: 8, state: 1, name: this.$t('CardGames') },
        { id: 11, state: 1, name: this.$t('Lottery') },
      ],
      MinorGameOrder: {
        1: [
          {
            id: 2,
            name: this.$t('textFilter.gameList2'),
            state: 1,
            checked: true,
          },

          {
            id: 1,
            name: this.$t('textFilter.gameList1'),
            state: 1,
            checked: true,
          },
          {
            id: 5,
            name: this.$t('textFilter.gameList5'),
            state: 1,
            checked: true,
          },
          {
            id: 12,
            name: this.$t('textFilter.gameList8'),
            state: 1,
          },
          {
            id: 11,
            name:this.$t('textFilter.gameList9'),
            state: 1,
            checked: true,
          },
          {
            id: 4,
            name: this.$t('textFilter.gameList4'),
            state: 1,
            checked: true,
          },
          {
            id: 102,
            name: "一分单双",
            state: 1,
            checked: true,
          },
          {
            id: 101,
            name: "一分大小",
            state: 1,
            checked: true,
          },
          {
            id: 105,
            name: "一分牛牛",
            state: 1,
            checked: true,
          },
          {
            id: 131,
            name: "三分大小",
            state: 1,
            checked: false,
          },
          {
            id: 132,
            name: "三分单双",
            state: 1,
            checked: false,
          },
          {
            id: 133,
            name: "三分幸运",
            state: 1,
          },
          {
            id: 134,
            name: "三分庄闲",
            state: 1,
            checked: false,
          },
          {
            id: 135,
            name: "三分牛牛",
            state: 1,
            checked: false,
          },
          {
            id: 3,
            name: this.$t('textFilter.gameList3'),
            state: 1,
            checked: true,
          },
          {
            id: 103,
            name: "一分幸运",
            state: 1,
          },
          {
            id: 104,
            name: "一分庄闲",
            state: 1,
            checked: true,
          },
          {
            id: 6,
            name: "哈希快三",
            state: 2,
            checked: true,
          },
          {
            id: 7,
            name: "哈希PK10",
            state: 2,
            checked: true,
          },
        ],
        2: this.onGetCompanyList(this.$global.EGameType.E_Slots),
        4: this.onGetCompanyList(this.$global.EGameType.E_Live),
        5: this.onGetCompanyList(this.$global.EGameType.E_Arcade),
        7: this.onGetCompanyList(this.$global.EGameType.E_Sport),
        8: this.onGetCompanyList(this.$global.EGameType.E_Table),
        11: this.onGetCompanyList(this.$global.EGameType.E_Lotto), // 彩票
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initSort();
    });
  },
  created() {
    if (
      this.smallSortData.rowData.MinorGameOrder &&
      this.smallSortData.rowData.MinorGameOrder != "{}"
    ) {
      let data = JSON.parse(this.smallSortData.rowData.MinorGameOrder);
      for (const key in data) {
        for (const key1 in this.MinorGameOrder) {
          if (key == key1) {
            this.MinorGameOrder[key1].forEach((item) => {
              data[key].forEach((ele) => {
                if (item.id == ele.id) {
                  item.state = ele.state;
                }
              });
            });
          }
          if (!data[key1]) {
            data[key1] = this.MinorGameOrder[key1];
          }
        }
        let tList = data[key];
        let tCompanyMap = app.GetCompany();

        for (let i = tList.length - 1; i >= 0; --i) {
          let tListItem = tList[i];
          let bHave = false;
          for (const pGameType in tCompanyMap) {
            let tHaveList = tCompanyMap[pGameType];
            for (const pIndex in tHaveList) {
              let tItem = tHaveList[pIndex];
              if (
                tListItem.name == tItem.Name ||
                tItem.Key == tListItem.id ||
                (tItem.KeyEx && tItem.KeyEx == tListItem.id)
              ) {
                bHave = true;
                break;
              }
            }
            if (bHave) {
              break;
            }
          }
          if (!bHave) {
            tList.splice(i);
            break;
          }
        }
      }
      for (const key in this.MinorGameOrder) {
        for (let i = 0; i < this.MinorGameOrder[key].length; i++) {
          let finded = false;
          for (let j = 0; j < data[key].length; j++) {
            if (data[key] && this.MinorGameOrder[key][i].id == data[key][j].id)
              finded = true;
          }
          if (!finded) {
            data[key].push(this.MinorGameOrder[key][i]);
          }
        }
      }
      this.MinorGameOrder = data;
    }
    this.dataList = this.gameList;
    this.dataList.forEach((item) => {
      item.tableData = [];
      for (const key in this.MinorGameOrder) {
        if (item.id == key) {
          item.tableData = this.MinorGameOrder[key];
        }
      }
    });
    this.dataList.forEach((item) => {
      if (item.tableData.length) {
        item.tableData.forEach((k) => {
          k.checked = k.state == 1 ? true : false;
        });
      }
    });
  },
  methods: {
    onGetCompanyList(pGameType) {
      let tList = app.GetCompany(pGameType);
      let tRetList = [];
      if (tList) {
        for (let i = 0; i < tList.length; ++i) {
          let tItem = tList[i];
          if (!tItem) {
            continue;
          }
          let tNewItem = {};
          tNewItem.id = tItem.Key;
          tNewItem.name = tItem.Name;
          tNewItem.state = 2;
          tNewItem.checked = false;
          if (pGameType == this.$global.EGameType.E_Sport && tItem.KeyEx) {
            tNewItem.id = tItem.KeyEx;
          }
          if (pGameType == this.$global.EGameType.E_Arcade && tItem.KeyEx) {
            tNewItem.id = tItem.KeyEx;
          }
          tRetList.push(tNewItem);
        }
      }
      return tRetList;
    },
    initSort() {
      this.dataList.forEach((k, index) => {
        if (k.tableData.length) {
          const el = document.querySelector(
            `#sortTable${index + 1} .el-table__body-wrapper > table > tbody`
          );
          new Sortable(el, {
            onEnd: (evt) => {
              const currRow = k.tableData.splice(evt.oldIndex, 1)[0];
              k.tableData.splice(evt.newIndex, 0, currRow);
            },
          });
        }
      });
    },
    confirmSort(type) {
      let obj = {};
      let data = {};
      this.dataList.forEach((item) => {
        if (item.tableData.length) obj[item.id] = item.tableData;
      });
      for (const key in obj) {
        data[key] = obj[key].map((item) => {
          return {
            id: item.id,
            name: this.$global.GameSortNameDef[item.id] || item.name,
            state: item.checked ? 1 : 2,
          };
        });
      }
      this.smallSortData.rowData.MinorGameOrder = JSON.stringify(data);
      this.smallSortData.rowData.IsBatch = type;
      this.$emit("confirmSmallSortData", this.smallSortData.rowData);
    },
  },
};
</script>

<style scoped>
.game-box {
  display: flex;
  overflow: auto;
  max-height: 610px;
}

.gameItem {
  margin-right: 20px;
  padding-bottom: 30px;
}

.gameItem:last-of-type {
  margin: 0;
}
</style>
